import {
  Flex,
  Text,
} from "@chakra-ui/react";
import { WithAuth } from "@/hoc";
import { usePlan } from "@/hooks";
import { useEffect, useState } from "react";
import { DynamicTable, ColumnDefinition } from "@/components/DynamicTable";
import { isExactFeatureToggle, showToast } from "@/utils";
import { PageHeading, Search, Toggle } from "barte-design-system";
import { PlanFormDrawer } from "@/layouts";
interface Plan {
  title: string;
  id: number;
  active: boolean;
}

interface MyPlansProps {
  plansList: Plan[];
}

const MyPlans = () => {
  const [plans, setPlans] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [drawerPlanId, setDrawerPlanId] = useState<string | null>(null);
  const featureTogglesUser = JSON.parse(
    localStorage.getItem("barte-features-list-user") || "[]"
  );
  const canManagePlans = isExactFeatureToggle(
    featureTogglesUser,
    "view_seller_plans_create"
  );
  async function getPlans() {
    const { getPlans } = usePlan();
    try {
      const { data } = await getPlans();
      setPlans(data);
      setFilteredData(data);
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`,
        });
      });
      setPlans([]);
      setFilteredData([]);
    }
  }

  useEffect(() => {
    getPlans();
  }, []);

  const { activatePlan } = usePlan();

  async function switchPlan(active: boolean, id: number) {
    try {
      await activatePlan(id, active);

      setPlans(
        plans.map((plan) => {
          if (plan.id === id) {
            return {
              ...plan,
              active,
            };
          }
          return plan;
        })
      );
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`,
        });
      });
    }
  }

  function handlePlan(active: any, id: any): void {
    try {
      switchPlan(!active, id);
      showToast({ message: "Plano atualizado com sucesso!", type: "success" });

    } catch (error) {
      showToast({ message: "Plano não pode ser atualizado!", type: "error" });

    }
  }

  const columns: ColumnDefinition<Plan>[] = [
    {
      key: "title",
      title: "Nome do plano",
      dataIndex: "title",
      width: "100%",
      render: (title: string) => (
        <Text
          fontSize="var(--typography-body-sm-fontSize)"
          color="var(--content-primary)"
        >
          {title}
        </Text>
      ),
    },
    {
      key: "active",
      title: "Status do plano",
      dataIndex: "active",
      align: "right",
      render: (active: boolean, record: Plan) => (
        <Flex w="fit-content" ml="auto" onClick={(e) => e.stopPropagation()}>
          <Toggle
            defaultChecked={active}
            onChange={() => handlePlan(record.active, Number(record.id))}
          />
        </Flex>
      ),
    },
  ];

  async function filterTable(searchParam?: string) {
    setLoading(true)
    if (!searchParam) {
      try {
        await getPlans();

      } catch (error) {

      } finally {
        setLoading(false)
      }
    }
    if (searchParam && plans.length > 0) {
      const filteredPlans = plans.filter(({ title }: any) => title.toLowerCase().includes(searchParam.toLowerCase()))
      setFilteredData(filteredPlans);
      setLoading(false)
    }
  }
  return (
    <>
      <PageHeading
        title="Meus planos"
        primaryActionLabel={canManagePlans ? "Criar plano" : undefined}
        onPrimaryAction={canManagePlans ? () => setDrawerPlanId("0") : undefined}
      />
        <Flex
          w="100%"
          gap="2"
          flexDirection="column"
        >
          <Search
            placeholder="Buscar planos"
            onSearch={filterTable}
            expanded
          />
          <DynamicTable
              data={filteredData}
              columns={columns}
              loading={loading}
              onRowClick={
                canManagePlans
                  ? (record) => setDrawerPlanId(String(record.id))
                  : undefined
              }
              rowKey={(record) => String(record.id)}
              pagination={{
                currentPage: currentPage,
                totalPages: Math.ceil(filteredData.length / pageSize),
                pageSize: pageSize,
                onPageSizeChange: (size) => setPageSize(size),
                onPageChange: (page) => setCurrentPage(page),
                totalItems: filteredData.length,
              }}
              locale={{ emptyText: "Sem Planos cadastrados" }}
            />
        </Flex>
        <PlanFormDrawer
          isOpen={drawerPlanId !== null}
          planId={drawerPlanId ?? undefined}
          onClose={() => setDrawerPlanId(null)}
          onSuccess={() => {
            setDrawerPlanId(null);
            getPlans();
          }}
        />
    </>
  );
};

export default WithAuth(MyPlans);
